import React from 'react';
import Badge from 'components/v2/Badge';
;
import i18next from 'i18next';
import { sluggify } from 'utils/localization/utils';
const CHASSIS_COLOR_MAPPING = {
    customer: 'orange',
    cargomatic: 'green',
};
const equipmentIdFormatter = (cell, row) => {
    return (React.createElement("a", { onClick: row.onClick, className: "uppercase break-words" }, cell));
};
const chassisOwnershipFormatter = (cell, row) => {
    return (cell &&
        React.createElement(Badge, { color: CHASSIS_COLOR_MAPPING[cell], size: "large" }, i18next.t(sluggify(cell))));
};
const columns = [
    {
        dataField: 'equipment_id',
        localizationSlug: 'EQUIPMENT_ID',
        text: 'Equipment ID',
        sort: true,
        formatter: equipmentIdFormatter,
        headerStyle: {
            width: '25%',
        },
    },
    {
        dataField: '_equipmentType',
        localizationSlug: 'ASSET_TYPE',
        text: 'Asset Type',
        sort: true,
    },
    {
        dataField: 'chassis_owner_type',
        localizationSlug: 'CHASSIS_OWNERSHIP',
        text: 'Chassis Ownership',
        sort: true,
        formatter: chassisOwnershipFormatter,
    },
    {
        dataField: '_type',
        localizationSlug: 'EQUIPMENT_TYPE',
        text: 'Equipment Type',
        sort: true,
    },
    {
        dataField: '_equipmentSize',
        localizationSlug: 'EQUIPMENT_SIZE',
        text: 'Equipment Size',
        sort: true,
    },
    {
        dataField: 'status',
        localizationSlug: 'STATUS',
        text: 'Status',
        sort: true,
    },
    {
        dataField: 'last_free_date',
        localizationSlug: 'FREE',
        text: 'Free',
        sort: true,
        type: 'datetime',
    },
    {
        dataField: 'earliest_empty_date',
        localizationSlug: 'EMPTY',
        text: 'Empty',
        sort: true,
        type: 'datetime',
    },
    {
        dataField: 'earliest_return_date',
        localizationSlug: 'RETURN',
        text: 'Return',
        sort: true,
        type: 'datetime',
    },
    {
        dataField: 'last_cut_date',
        localizationSlug: 'CUT',
        text: 'Cut',
        sort: true,
        type: 'datetime',
    },
    {
        dataField: 'shipment',
        localizationSlug: 'SHIPMENT',
        count: 1,
        text: 'Shipment',
        type: 'entity',
        entityType: 'shipment',
        formatExtraData: {
            attribute: 'shipment_id',
        },
        hideable: true,
        sort: true,
    },
    {
        dataField: 'order',
        localizationSlug: 'ORDER',
        text: 'Order',
        type: 'entity',
        entityType: 'order',
        formatExtraData: {
            attribute: 'order_id',
        },
        hideable: true,
        sort: true,
    },
];
export default {
    columns,
};
